import { Component, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { ITypesSelection } from 'src/app/core/interfaces/types-selection.interface';
import { TexteService } from 'src/app/core/services/texte.service';
import { ApiService, ItemDto } from 'src/app/core/services/api.service';
import { faHeadset, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-types-selection',
    templateUrl: './types-selection.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TypesSelectionComponent implements OnInit {

  @Output() selection: EventEmitter<ITypesSelection> = new EventEmitter<ITypesSelection>();

  public situations: ItemDto[];
  public situation: ItemDto;

  // Français
  public demandes: ItemDto[];
  public demande: ItemDto;
  public displayDemande?: boolean;
  public demandeChange: boolean;
  public displaySecondAvisFrancaise: boolean;
  public showSecondOpinionFr = false;
  public showSecondOpinionInternational = false;

  // Internationnal
  public secondAvis?: boolean;
  public secondAvisAllowed?: boolean;
  public displaySecondAvis?: boolean;
  public couvertures: ItemDto[];
  public couverture: ItemDto;
  public displayCouverture?: boolean;

  public faCalendarAlt = faCalendarAlt;
  public faHeadset = faHeadset;

  constructor(
    public texteService: TexteService,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.situation = null;
    this.apiService.getSecondAvisAllowed().subscribe(data => {
      if (data === "TRUE") {
        this.secondAvisAllowed = true;
      }
      else if (data === "FALSE") {
        this.secondAvisAllowed = false;
      }      
    });
    this.apiService.getTypeSituations().subscribe(data => {
      this.situations = data;
    });
    this.apiService.getTypeDemandes().subscribe(data => {
      this.demandes = data;
    });
    this.apiService.getTypeCouvertures().subscribe(data => {
      this.couvertures = data;
    });

    this.initLevel2();
    this.initLevel3();
  }

  initLevel2() {
    this.displayDemande = false;
    this.displaySecondAvisFrancaise = false;
    this.demande = null;
    this.demandeChange = false;
    this.displaySecondAvis = false;
    this.secondAvis = null;
    this.showSecondOpinionFr = false;
    this.showSecondOpinionInternational = false;
  }

  initLevel3() {
    this.displayCouverture = false;
    this.couverture = null;
  }

  onTypeSituationSelected(type: string) {
    const typeS = this.situations.filter(s => s.code === type)[0];
    if (this.situation === typeS) { return; }
    this.situation = typeS;

    this.initLevel2();
    this.initLevel3();

    if (this.situation.code === 'FRA') {
      this.displayDemande = true;
      this.displaySecondAvisFrancaise = true;
      this.displaySecondAvis = false;
      this.selection.emit(null);
    } else if (this.situation.code === 'MED') {
      this.selection.emit({ situation: this.situation });
    } else {
      this.displaySecondAvis = this.secondAvisAllowed;
      this.displaySecondAvisFrancaise = false;
      if(!this.displaySecondAvis){
        this.displayCouverture = true;
      }
      this.selection.emit(null);
    }
  }

  // Patient français
  onSecondAvisFrancaiseSelected(type: boolean) {
    this.secondAvis = type;
    if (type) {
      this.initLevel3();
      this.showSecondOpinionFr = true;
      this.selection.emit(null);
    } else {
      this.showSecondOpinionFr = false;
      this.onTypeDemandeSelected('NOU');
      this.displayDemande = true;
    }
  }
  onTypeDemandeSelected(type: string) {
    const typeD = this.demandes.filter(s => s.code === type)[0];
    if (this.demande !== typeD) {
      this.demande = typeD;
      this.demandeChange = true;
    }

    this.selection.emit({
      situation: this.situation,
      demande: this.demande
    });
  }

  // Patient internationnal
  onSecondAvisSelected(type: boolean) {
    this.secondAvis = type;
    if (type) {
      this.initLevel3();
      this.showSecondOpinionInternational = true;
      this.selection.emit(null);
    } else {
      this.showSecondOpinionInternational = false;
      this.displayCouverture = true;
    }
  }

  onTypeCouvertureSelected(type: string) {
    const typeC = this.couvertures.filter(s => s.code === type)[0];
    if (this.couverture === typeC) { return; }
    this.couverture = typeC;

    this.selection.emit({
      situation: this.situation,
      couverture: this.couverture
    });
  }
}
